import { render, staticRenderFns } from "./ScheduleFrequencyDay.vue?vue&type=template&id=0906b00a&scoped=true"
import script from "./ScheduleFrequencyDay.vue?vue&type=script&lang=js"
export * from "./ScheduleFrequencyDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906b00a",
  null
  
)

export default component.exports